import DownloadCard from "../../../common/DownloadCard";
import ModalTemplate from "../../../common/ModalTemplate";
import { theme } from "../../../theme";

const Body = ({ error, handleClose }) => {
    return (
        <div className="bg-white rounded-4 shadow p-4 text-center">
            {/* Warning Icon */}
            <div className="mb-3">
                <img src="./assets/img/error-warning-icon.png" alt="Warning" style={{ height: "80px" }} />
            </div>

            {/* Error Message */}
            <h6 className="text-secondary fw-semibold mb-2">{error?.message}</h6>

            {/* App Download Section */}
            <h6 className={`text-${theme.main} fw-bold mt-4 mb-3`}>CONTINUE WITH OUR APP</h6>

            {/* Android Download Card */}
            <DownloadCard
                platform="ANDROID"
                qrSrc={error?.android?.qr}
                badgeHeight="40px"
            />

            {/* iOS Download Card */}
            <DownloadCard
                platform="IOS"
                qrSrc={error?.ios?.qr}
                badgeHeight="40px"
            />

            {/* Web Section */}
            <h6 className={`text-${theme.main} fw-bold mt-4 mb-3`}>CONTINUE WITH OUR WEB</h6>

            {/* {error?.onboarding_key?.map((item) => (
                <CopyUrlBox
                    key={item.onboarding_key}
                    url={`${window.location.href}${item.onboarding_key}`}
                    name="Link"
                />
            ))} */}

            <button
                className={`btn btn-${theme.main} px-4 py-2 fw-bold mt-4 w-100`}
                onClick={() => handleClose()}
            >
                Use Another {error?.type?.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}
            </button>
        </div>
    );
};

const Error = ({ show, handleClose, error }) => (
    <ModalTemplate
        show={show}
        handleClose={handleClose}
        size={null}
        centered
        title={null}
        body={<Body error={error} handleClose={handleClose} />}
        footer={null}
        backdrop="static"
        keyboard={false}
    />
);

export default Error;